module.exports = __webpack_public_path__ + "static/media/generic-file.660d29bb.png";